@if (nvb$ | async; as nvb) {
  <rask-toggle-panel label="Naturvärdesbedömning/Riskbedömning" [defaultExpanded]="false">
    <rask-label size="12" class="p-0">
      Har kontraktet i sin helhet, eller finns det i något delområde, områden större än 0.5 ha som har någon av följande kvaliteter?
    </rask-label>
    <div style="width: fit-content">
      <div class="row">
        <div class="col-1"><b>Ja</b></div>
        <div class="col-1"><b>Nej</b></div>
      </div>
      @for (item of nvb.items; track item) {
        <div class="row mt-1">
          <div class="col-1">
            <input type="radio" disabled [name]="item.naturvardestyp" [value]="true" [ngModel]="item.applicable" />
          </div>
          <div class="col-1">
            <input type="radio" disabled [name]="item.naturvardestyp" [value]="false" [ngModel]="item.applicable" />
          </div>
          <div class="col d-flex flex-column">
            <div>{{item.naturvardestyp}}</div>
            @if (item.applicable) {
              <rask-textarea class="m-0 p-0"
                placeholder="Anteckning krävs här*"
                disabled
                [value]="item.anteckning">
              </rask-textarea>
            }
          </div>
        </div>
      }
    </div>
    <p class="mt-3">
      Är svaret ja på någon av ovanstående frågor tillkalla nyckelbiotopsinventerare eller annan sakkunnig för naturvärdesbedömning av skogen.<br/>
      Lämnas delområdet som hänsyn behöver inte nyckelbiotopsinventerare tillkallas.
    </p>
    <div class="d-flex flex-column">
      <rask-checkbox class="p-0 m-0"
        disabled
        label="Hur gjordes bedömningen?"
        text="Besiktning i fält"
        [ngModel]="nvb.besiktningFalt">
      </rask-checkbox>
      <rask-checkbox class="p-0 m-0"
        disabled
        text="Kartstudier på rummet (skogens pärlor)"
        [ngModel]="nvb.kartstudier">
      </rask-checkbox>
      <rask-checkbox class="p-0 m-0"
        disabled
        text="Välkänd leverantör där vi har stor lokalkännedom"
        [ngModel]="nvb.valkandLeverantor">
      </rask-checkbox>
    </div>
    <rask-textarea class="p-0 w-100"
      label="Undantag och kompletterande information"
      [maxlength]="500"
      [(ngModel)]="kompletterandeInformation"
      (ngModelChange)="kompletterandeInfoChanged()">
    </rask-textarea>
    <rask-checkbox class="p-0 m-0"
      disabled
      text="Naturvärdesbedömning utförd på samtliga åtgärder"
      [ngModel]="nvb.bedomningUtford">
    </rask-checkbox>
  </rask-toggle-panel>
}
